import { render, staticRenderFns } from "./GroupsPushCustomer.vue?vue&type=template&id=ce645864&"
import script from "./GroupsPushCustomer.vue?vue&type=script&lang=ts&"
export * from "./GroupsPushCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports